import React, { useState } from 'react'
import PropTypes from 'prop-types'

import ProfileAvatar from '../profile-avatar'
import Button from '../../../../components/button'
import styles from './profiles-avatar-form.css'

const avatarPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired
})

/** Lets user choose the avatar used by a profile. */
function ProfilesAvatarForm({
  error,
  isSubmitting,
  selectedAvatar,
  setSelectedAvatar,
  setIsAvatarSelected,
  avatars,
  onCancel
}) {
  const [selectedAvatarState, setSelectedAvatarState] = useState(selectedAvatar)
  const onNextClick = (event) => {
    event.preventDefault()
    setSelectedAvatar(selectedAvatarState)
    setIsAvatarSelected(false)
  }
  const onCancelClick = (event) => {
    event.preventDefault()
    onCancel()
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Choose your profile picture
        </h1>
        <span className={styles.subHeader}>
          You can change this at any time when you edit your profile
        </span>
      </div>
      <div className={styles.avatarList}>
        {
          avatars.map((avatar, index) => {
            const isSelected = selectedAvatarState?.id === avatar.id
            const avatarClass = isSelected
              ? styles.selectedItem
              : styles.avatarListItem

            return (
              <button
                type="button"
                className={avatarClass}
                key={avatar.id}
                aria-label={`Select avatar ${index + 1}`}
                aria-pressed={isSelected}
                onClick={() => setSelectedAvatarState(avatar)}
              >
                <ProfileAvatar uri={avatar.uri} />
              </button>
            )
          })
        }
      </div>
      <div className={styles.buttonWrapper}>
        <div className={styles.buttonContainer}>
          <div className={styles.saveWrapper}>
            <Button
              disabled={isSubmitting || !selectedAvatarState}
              text="Next"
              onClick={onNextClick}
              error={error}
              lightBGPrimary
            />
          </div>
          <div className={styles.cancelWrapper}>
            <Button
              disabled={isSubmitting}
              text="Cancel"
              onClick={onCancelClick}
              secondary
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ProfilesAvatarForm.propTypes = {
  error: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  setIsAvatarSelected: PropTypes.func.isRequired,
  setSelectedAvatar: PropTypes.func.isRequired,
  selectedAvatar: avatarPropType,
  avatars: PropTypes.arrayOf(avatarPropType).isRequired
}

ProfilesAvatarForm.defaultProps = {
  error: '',
  selectedAvatar: null,
  isSubmitting: false
}

export default ProfilesAvatarForm
